<template>
	<div v-if="imageId" class="my-3">
		<ResponsiveImage :image="imageUrl" :height-proportion="ratio" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from '@/js/stores/index';
import ResponsiveImage from './responsive-image.vue';

import { challengeSettings } from "../../../../customer.json" with { type: "json" };

// Constants
const cropDimensions = challengeSettings?.largeImageCropDimensions
const ratio = cropDimensions ? cropDimensions?.[1] / cropDimensions?.[0] * 100 : undefined

const store = useStore()

// Model
const imageId = defineModel<string|number|boolean>()

// Computeds
const imageUrl = computed(() => ratio
	// If proportions are provided - limit it
	? masterServerUrl.value + `/image/i.${imageId.value}/w.${cropDimensions[0]}:h.${cropDimensions[1]}:f.1/image.png`
	// Otherwise keep the file original
	: masterServerUrl.value + `/image/i.${imageId.value}/image.png`
)
const masterServerUrl = computed(() => store.settings?.masterServerUrl)
</script>